import React, { useCallback, useEffect, useState } from 'react';
import {
  DialogProps,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

import { useStylesPromocodeEdit } from '../hooks/useStyles';
import { IUser } from '../../../auth/interfaces';
import { Modal } from '../../../../components/other/Modals';
import { useFormatMessage } from '../../../../hooks';
import AdminsList from '../../orders/components/AdminsList';
import { useSearchUsers } from '../../users/users/hooks/useSearchUsers';
import VendorsList from '../../orders/components/VendorsList';
import OperatorsList from '../../orders/components/OperatorsList';

export interface IProps {
  selectedOperator?: IUser;
  setSelectedOperator: (user?: IUser) => void;
  setChangeRange: (change: boolean) => void;
}

const FillterByOperator: React.FC<IProps> = ({
  selectedOperator,
  setSelectedOperator,
  setChangeRange,
}) => {
  const fm = useFormatMessage();
  const classes = useStylesPromocodeEdit();
  const [showModal, setModal] = useState(false);
  const [radioValue, setRadio] = useState<'driver' | 'cashier' | 'admin'>('driver');
  const roles = // eslint-disable-next-line no-nested-ternary
  radioValue === 'admin'
    ? 'ROLE_MANAGER,ROLE_ADMIN'
    : radioValue === 'cashier'
    ? 'ROLE_CASHIER'
    : 'ROLE_VENDOR';


  const {
    fetchUsers: fetchSearchUsers,
    loading: searchLoading,
    loadingPhone,
    page: searchPage,
    perPage: searchPerPage,
    total: searchTotal,
    users: searchUsers,
  } = useSearchUsers();

  const {
    fetchUsers,
    loading: loadingUsers,
    page: pageUsers,
    perPage: perPageUsers,
    total: totalUsers,
    users,
  } = useSearchUsers();

  const searchGetUsersStaff = useCallback(
    (data: { fio?: string; phone?: string; id?: number }) => {
      fetchSearchUsers({
        page: searchPage,
        per_page: searchPerPage,
        fio: data.fio,
        phone: data.phone,
        id: data.id,
        roles,
      });
    },
    [searchPage, searchPerPage, roles]
  );

  useEffect(() => {
    if (showModal) {
      fetchUsers({ page: 1, per_page: 20, roles });
    }
  }, [roles, showModal]);

  return (
    <div className={classes.from} style={{ paddingBottom: 10 }}>
      <Typography variant='h6' className={classes.title}>
        Автор транзакции
      </Typography>

      <div className={classes.picerContainer}>
        <TextField
          type='text'
          label='Автор транзакции'
          margin='normal'
          value={`${
            selectedOperator?.fio
              ? `${selectedOperator?.fio}${selectedOperator?.phone ? `,` : ''}`
              : ''
          } ${selectedOperator?.phone ? `+${selectedOperator?.phone}` : ''}`}
          variant='outlined'
          onClick={() => setModal(true)}
          InputProps={{
            readOnly: true,
            endAdornment: (
              <>
                {selectedOperator && (
                  <IconButton size='small' onClick={() => setSelectedOperator(undefined)}>
                    <ClearIcon fontSize='small' />
                  </IconButton>
                )}
              </>
            ),
          }}
        />
      </div>
      <Modal
        DialogProps={{ maxWidth: 'md' } as DialogProps}
        open={showModal}
        loading={loadingUsers}
        onClose={() => setModal(false)}
        title='Автор транзакции'
        content={
          <>
            <RadioGroup
              name='deliveryType'
              value={radioValue}
              onChange={(e: any) => setRadio(e.target.value)}
              style={{ flexDirection: 'row' }}
            >
              <FormControlLabel value='admin' control={<Radio />} label='Администраторы' />
              <FormControlLabel value='driver' control={<Radio />} label='Таксисты' />
              <FormControlLabel value='cashier' control={<Radio />} label='Кассиры' />
            </RadioGroup>
            {radioValue === 'admin' && !loadingUsers && (
              <AdminsList
                searchUsers={searchUsers}
                searchLoading={searchLoading}
                searchGetUsersStaff={searchGetUsersStaff}
                users={users}
                setFieldValue={(_fieldName: string, value: any) => {
                  setSelectedOperator(value);
                  setChangeRange(true);
                }}
                values={{ admin: selectedOperator }}
                pageUsers={pageUsers}
                perPageUsers={perPageUsers}
                totalUsers={totalUsers}
                fetchUsers={fetchUsers}
                closeDriverModal={() => setModal(false)}
              />
            )}
            {radioValue === 'driver' && !loadingUsers && (
              <VendorsList
                searchUsers={searchUsers}
                searchLoading={searchLoading}
                searchGetUsersStaff={searchGetUsersStaff}
                users={users}
                setFieldValue={(_fieldName: string, value: any) => {
                  setSelectedOperator(value);
                  setChangeRange(true);
                }}
                values={{ driver: selectedOperator }}
                pageUsers={pageUsers}
                perPageUsers={perPageUsers}
                totalUsers={totalUsers}
                fetchUsers={fetchUsers}
                closeDriverModal={() => setModal(false)}
              />
            )}
            {radioValue === 'cashier' && !loadingUsers && (
              <OperatorsList
                searchUsers={searchUsers}
                searchLoading={searchLoading}
                searchGetUsersStaff={searchGetUsersStaff}
                users={users}
                setFieldValue={(_fieldName: string, value: any) => {
                  setSelectedOperator(value);
                  setChangeRange(true);
                }}
                values={{ operator: selectedOperator }}
                pageUsers={pageUsers}
                perPageUsers={perPageUsers}
                totalUsers={totalUsers}
                fetchUsers={fetchUsers}
                closeDriverModal={() => setModal(false)}
              />
            )}
          </>
        }
        actions={[
          {
            title: fm('COMMON.BUTTON.CLOSE'),
            onClick: () => setModal(false),
          },
        ]}
      />
    </div>
  );
};

export default React.memo(FillterByOperator);
